var map = {
	"./en.json": 1090,
	"./fr.json": 1091
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1581;



//////////////////
// WEBPACK FOOTER
// ./src/helpers ^\.\/.*\.json$
// module id = 1581
// module chunks = 0